import { ManIcon, WomanIcon } from 'components/icons/customIcons';

/**
 * Codes du référentiel Civilité, miroir du back (Codes.Civilites : Mr / Mme / NC).
 */
export const CivilityCodes = {
  Mr: 'Mr',
  Mme: 'Mme',
  NC: 'NC'
} as const;

// Tolère la casse historique ('MME') présente dans certaines données.
const FEMALE_CIVILITY_CODES = [CivilityCodes.Mme, 'MME'];

/** Vrai si le code de civilité correspond à une femme (Mme). */
export const isFemaleCivility = (civilityCode?: string | null): boolean =>
  !!civilityCode && FEMALE_CIVILITY_CODES.includes(civilityCode);

/**
 * Icône avatar correspondant à la civilité : femme → WomanIcon, sinon ManIcon
 * (NC et inconnu retombent sur ManIcon, comportement historique).
 */
export const getCivilityIcon = (civilityCode?: string | null) =>
  isFemaleCivility(civilityCode) ? WomanIcon : ManIcon;
